import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { useAppContext } from "../../../lib/AppContext";
import "./SampleLibraries.scss";

const TOOLS = ["Reaper", "Pro Tools", "Logic Pro", "Ableton Live", "iZotope RX", "Kontakt"];

// Moves the card's glow to follow the cursor
const trackPointer = (e) => {
  const rect = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - rect.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - rect.top}px`);
};

function LibraryCard({ library, index }) {
  const content = (
    <>
      <span className="library-card-index">{String(index + 1).padStart(2, "0")}</span>
      {library.imageUrl && (
        <img className="library-card-cover" src={library.imageUrl} alt="" loading="lazy" />
      )}
      <div className="library-card-body">
        <span className="library-card-brand">{library.brand}</span>
        <h3 className="library-card-name">{library.name}</h3>
        <p className="library-card-role">{library.role}</p>
      </div>
      {library.link && <FiArrowUpRight className="library-card-arrow" aria-hidden />}
    </>
  );

  return library.link ? (
    <a
      className="library-card"
      href={library.link}
      target="_blank"
      rel="noopener noreferrer"
      onMouseMove={trackPointer}
    >
      {content}
    </a>
  ) : (
    <div className="library-card" onMouseMove={trackPointer}>
      {content}
    </div>
  );
}

function SampleLibraries() {
  const { sampleLibraries } = useAppContext();

  return (
    <div className="sample-libraries">
      <div className="sample-libraries-intro">
        <h2>Sample Editing &amp; Sound Design</h2>
        <p>
          Transforming raw recordings into polished, balanced, and expressive samples, carefully
          refined for virtual instruments and professional sample libraries. Combining technical
          precision with creative sound shaping to deliver clean, consistent, and production-ready
          audio.
        </p>
        <div className="sample-libraries-tools">
          <span className="sample-libraries-tools-label">Software &amp; Tools</span>
          <ul>
            {TOOLS.map((tool) => (
              <li key={tool}>{tool}</li>
            ))}
          </ul>
        </div>
      </div>

      <ol className="sample-libraries-list">
        {sampleLibraries.map((library, index) => (
          <li key={library.id}>
            <LibraryCard library={library} index={index} />
          </li>
        ))}
      </ol>
    </div>
  );
}

export default SampleLibraries;
